/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
export function getRuntimeEnvVar(key: string, defaultValue?: any): any {
  if (!process.env.USE_SERVER_VARS) {
    return defaultValue;
  }

  if (typeof window === 'object') {
    if (!(window as any)['env']) {
      throw new Error('window.env is not defined. Have you run inject-env script ?');
    }
    if (!(window as any)['env'][key]) {
      console.warn(
        `window['env']['${key}'] is undefined. Provide it in your helm chart & add the key to the variable injection whitelist.`
      );
    }
    return (window as any)['env'][key];
  }
  if (typeof global === 'object') {
    if (!(global as any)['ANGULAR_ENV']) {
      console.warn(
        'global.ANGULAR_ENV has not been set in SSR environment. Define it in your entrypoint if you need it.'
      );
    }
    return ((global as any)['ANGULAR_ENV'] || {})[key];
  }
}

export function getBuildEnvVar(key: string, defaultValue?: any): any {
  if (!process.env.USE_SERVER_VARS) {
    return defaultValue;
  }

  if (!process.env[key]) {
    throw new Error(`${key} variable has not been defined in your webpack build configuration.`);
  }
  return process.env[key];
}
